import React, { useContext, useState } from "react";
import errorRedIcon from "../../images/errorRedIcon.png";
// import { UserContext } from '../../pages/ExpertDetails';
import Swal from "sweetalert2";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";
import { useNavigate } from "react-router-dom";

export default function DeleteExpert({ expertID }) {
  const [deletePopup, setDeletePopup] = useState(false);
  const [loadingPopup, setLoadingPopup] = useState(false);
  const { API_URL } = useContext(UrlContext);
  const [ action, setAction] = useState("")
  const navigate = useNavigate();

  // const accessUser = useContext(UserContext);
  // const [adminUser, setAdminUser] = useState(false)

  // useEffect(() => {
  //    const accessToDeleteUser = ['David', 'Bappi']
  //    const myUsername = accessUser?.username
  //    if (accessToDeleteUser.includes(myUsername)) {
  //       setAdminUser(true)
  //    } else {
  //       setAdminUser(false)
  //    }

  // }, [accessUser])

  const blackListExpertHandler = () => {
    setAction('blacklist')
    setDeletePopup(false);
    setLoadingPopup(true);
    const url = `${API_URL}blacklist-expert`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        expertID: expertID,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoadingPopup(false);
        if (data.status === "success") {
          Swal.fire({
            title: "Success!",
            text: "Expert has been blacklisted successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            navigate(`/app/ProjectsOverview`);
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        setLoadingPopup(false);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong!",
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  const deleteExpertHandler = () => {
    setDeletePopup(false);
    setAction('delete')
    setLoadingPopup(true);
    const url = `${API_URL}delete-expert`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        expertID: expertID,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoadingPopup(false);
        if (data.status === "success") {
          Swal.fire({
            title: "Success!",
            text: "Expert has been deleted successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            navigate(`/app/ProjectsOverview`);
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: "Something went wrong!",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        setLoadingPopup(false);
        Swal.fire({
          title: "Error!",
          text: "Something went wrong!",
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  // if (!adminUser) {
  //    return null
  // }
  return (
    <>
      <button className="btn deleteButton" onClick={() => setDeletePopup(true)}>
        <i className="fa fa-trash" /> Delete
      </button>

      {deletePopup && (
        <div className="delete-popup-wrapper">
          <div className="tab-pane fade show deleteEx-div">
            <button
              style={{
                top: "0px",
                right: "0px",
                // background: "transparent",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
              }}
              onClick={() => setDeletePopup(false)}
            >
              &times;
            </button>
            <div>
              <center>
                <img src={errorRedIcon} width="50px" height="50px" alt="" />
                <p>
                  <strong>WARNING!</strong> Do you want to <strong>permanently remove</strong> or <strong>blacklist</strong> the expert?
                </p>
                <br />
              </center>
            </div>
            <div>
              <center>
                <button
                  className="btn base-light"
                  onClick={blackListExpertHandler}
                >
                  BLACKLIST
                </button>
                <button
                  className="btn base-btn"
                  style={{ marginLeft: "6px" }}
                  onClick={deleteExpertHandler}
                >
                  DELETE
                </button>
              </center>
            </div>
          </div>
        </div>
      )}

      {loadingPopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <center>
              <p style={{ fontSize: "18px" }}>
                Deleting data. Please wait . . .
              </p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
